import { render } from "./fqcForm.vue?vue&type=template&id=45f5118e&ts=true"
import script from "./fqcForm.vue?vue&type=script&lang=ts"
export * from "./fqcForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__